import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof console !== 'undefined' && console.error) {
      console.error('UI ErrorBoundary:', error, info);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const message =
      (this.state.error && (this.state.error.message || String(this.state.error))) ||
      'Erro inesperado na interface.';

    return (
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="card max-w-md w-full border-iron-danger/50 text-center">
          <h1 className="font-display text-2xl tracking-wider text-iron-danger mb-2">
            Algo deu errado
          </h1>
          <p className="font-mono text-xs text-iron-muted mb-4 break-words">
            {message}
          </p>
          <div className="flex flex-col gap-2">
            <button
              type="button"
              onClick={this.handleReset}
              className="btn-primary py-2"
            >
              Tentar novamente
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-secondary py-2"
            >
              Recarregar página
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
